module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "quotas"
  }, [_c('div', {
    staticClass: "rangesList"
  }, [_vm._l((_vm.quotas), function(quota, index) {
    return _c('div', {
      staticClass: "field quota",
      class: _vm.getQuotaDivClass(quota, index)
    }, [_c('div', {
      staticClass: "is-inline-block gender"
    }, [_c('vb-switch', {
      attrs: {
        "type": "danger rounded",
        "size": "medium"
      },
      model: {
        value: (quota.gender),
        callback: function($$v) {
          _vm.$set(quota, "gender", $$v)
        },
        expression: "quota.gender"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "is-inline-block age"
    }, [_c('vue-slider', {
      attrs: {
        "tooltip": 'always',
        "tooltip-placement": ['top', 'top'],
        "contained": true,
        "max": _vm.quotasParam.maxAge,
        "marks": _vm.quotasParam.marks,
        "railStyle": _vm.getSliderRailStyle(quota),
        "tooltipStyle": _vm.getSliderTooltipStyle(quota),
        "processStyle": _vm.getSliderProcessStyle(quota)
      },
      model: {
        value: (quota.age),
        callback: function($$v) {
          _vm.$set(quota, "age", $$v)
        },
        expression: "quota.age"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "field highLimit"
    }, [_c('div', {
      staticClass: "control"
    }, [_c('label', {
      staticClass: "checkbox"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('campaigns.quotas.noLimit')))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": !_vm.isRange(quota.age)
      },
      on: {
        "change": function($event) {
          return _vm.toggleHighLimit(!this.event.target.checked, quota)
        }
      }
    })])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "control is-inline-block limit"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (quota.limit),
        expression: "quota.limit"
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "placeholder": "limit",
        "min": "0"
      },
      domProps: {
        "value": (quota.limit)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(quota, "limit", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "control is-inline-block summary"
    }, [_c('span', [_vm._v(_vm._s(_vm.getQuotaSummary(quota)))])])])
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-rounded",
    on: {
      "click": function($event) {
        return _vm.addQuota()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle"
  }), _vm._v(_vm._s(_vm.$t('campaigns.quotas.addQuotas')))])], 2)]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary save",
    on: {
      "click": function($event) {
        return _vm.saveQuotas()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.save')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a995ceb2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/campaigns/quota/CampaignQuota.vue
// module id = 447
// module chunks = 42